/**
 * Review Health display helpers (Products list, product details card, Alerts page).
 * Every numeric field can be null = unknown: shown as "—", never 0.
 */

var MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** Finite number or null (null / '' / NaN → null). */
export function numOrNull (v) {
  if (v == null || v === '') return null
  var n = Number(v)
  return isFinite(n) ? n : null
}

/** 4.2 → "4.2"; null → "—". */
export function formatRating (v) {
  var n = numOrNull(v)
  return n == null ? '—' : n.toFixed(1)
}

/** 1191 → "1,191"; null → "—". */
export function formatCount (v) {
  var n = numOrNull(v)
  return n == null ? '—' : Math.round(n).toLocaleString('en-US')
}

/**
 * "★ 4.2 (1,191)", "★ 4.2" without a count, "—" without a rating. Amazon ratings start at 1.0, so a 0
 * (what the products API sent for "unknown" before it switched to null) is treated as unknown too.
 */
export function ratingSummary (rating, count) {
  var r = numOrNull(rating)
  if (r == null || r <= 0) return '—'
  var c = numOrNull(count)
  return '★ ' + formatRating(rating) + (c == null ? '' : ' (' + formatCount(c) + ')')
}

/** "2026-10-19" → "19 Oct" (or "19 Oct 2026" with withYear). Date-only strings are not shifted by timezone. */
export function formatSnapshotDate (value, withYear) {
  if (!value) return ''
  var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value))
  var y, mo, d
  if (m) {
    y = Number(m[1]); mo = Number(m[2]) - 1; d = Number(m[3])
  } else {
    var dt = new Date(value)
    if (isNaN(dt.getTime())) return ''
    y = dt.getFullYear(); mo = dt.getMonth(); d = dt.getDate()
  }
  return d + ' ' + MONTHS_SHORT[mo] + (withYear ? ' ' + y : '')
}

/** Signed difference "+12" / "−93" (true minus sign); null when either side is unknown. */
export function formatSignedDelta (current, previous) {
  var c = numOrNull(current)
  var p = numOrNull(previous)
  if (c == null || p == null) return null
  var diff = Math.round(c - p)
  if (diff === 0) return '0'
  return (diff > 0 ? '+' : '−') + Math.abs(diff).toLocaleString('en-US')
}

/** statusDetails key in snake_case or camelCase. */
function pick (details, snake, camel) {
  if (!details) return undefined
  return details[snake] != null ? details[snake] : details[camel]
}

/**
 * review_health statusDetails → { rows: [{ reason, text }], variationAsins: [], reviewsUrl }.
 * Accepts snake_case (as stored) and camelCase keys.
 */
export function reviewHealthDetails (details) {
  var d = details && typeof details === 'object' ? details : {}
  var reasons = pick(d, 'reasons', 'reasons')
  if (!Array.isArray(reasons)) reasons = []
  var rows = []
  reasons.forEach(function (reason) {
    if (reason === 'rating_drop') {
      rows.push({
        reason: reason,
        text: 'Star rating ' + formatRating(pick(d, 'previous_display_rating', 'previousDisplayRating')) +
          ' → ' + formatRating(pick(d, 'display_rating', 'displayRating'))
      })
    } else if (reason === 'rating_count_drop') {
      var cur = pick(d, 'total_rating_count', 'totalRatingCount')
      var prev = pick(d, 'previous_total_rating_count', 'previousTotalRatingCount')
      var delta = formatSignedDelta(cur, prev)
      rows.push({
        reason: reason,
        text: 'Rating count ' + formatCount(prev) + ' → ' + formatCount(cur) + (delta ? ' (' + delta + ')' : '')
      })
    } else if (reason === 'new_critical_reviews') {
      var n = numOrNull(pick(d, 'low_rating_review_count', 'lowRatingReviewCount'))
      rows.push({
        reason: reason,
        text: n == null ? 'New critical reviews' : n + ' new critical review' + (n === 1 ? '' : 's')
      })
    }
  })
  var variations = pick(d, 'variation_asins', 'variationAsins')
  var variationAsins = Array.isArray(variations) ? variations.filter(Boolean) : []
  var reviewsUrl = pick(d, 'reviews_url', 'reviewsUrl') || null
  var criticalUrl = pick(d, 'critical_reviews_url', 'criticalReviewsUrl') || null
  return {
    rows: rows,
    variationAsins: variationAsins,
    reviewsUrl: (reasons.indexOf('new_critical_reviews') >= 0 && criticalUrl) ? criticalUrl : reviewsUrl
  }
}



// WEBPACK FOOTER //
// ./src/utils/reviewHealth.js